/**
 * Created by mnaughton on 1/18/2016.
 */

import log from "loglevel";
import _ from "underscore";
var logger = log.getLogger("global");

var Logger = function () {
  var originalFactory = log.methodFactory;

  logger.methodFactory = function (methodName, logLevel, loggerName) {
    var rawMethod = originalFactory(methodName, logLevel, loggerName);

    if (methodName == "error") {
      return function (normalizedError) {
        if (window.Intercom) {
          var attrs = _.extend({}, normalizedError);

          if (
            normalizedError.originalError &&
            normalizedError.originalError.name
          ) {
            attrs.name = normalizedError.originalError.name;
          }

          delete attrs.originalError;

          window.Intercom("trackEvent", "error", attrs);
        }

        if (window._errs) {
          _.extend(_errs.meta, {
            correlationId: normalizedError.correlationId,
          });
        }

        rawMethod(normalizedError);
      };
    } else {
      return rawMethod;
    }
  };
  logger.setLevel("info");

  this.log = logger;
};

function sterilizeRoute(route) {
  return String(route).replace(/[0-9a-f]{24}|[0-9a-z]{16}|[0-9]{1}$/gi, "<id>"); //replace mongo ID or nedb ID with <id>
}

function sterilizeOptions(options) {
  if (!options) {
    return;
  }

  var result = {};
  var keys = _.keys(options);

  _.each(keys, function (key) {
    var value = options[key];

    if (_.isString(value) || _.isNumber(value) || _.isBoolean(value)) {
      options[key] = value;
    } else if (_.isObject(value)) {
      // see https://developers.intercom.com/reference#event-metadata-types
      if (_.size(value) == 2 && value.url && value.value) {
        //if it's an intercom-style "rich link"
        options[key] = value;
      }
    }
  });

  return result;
}

Logger.prototype = {
  navigation: function (route, options) {
    options = sterilizeOptions(options);

    if (window.Intercom) {
      //this.intercom('trackEvent', route, options);
      window.Intercom(
        "trackEvent",
        sterilizeRoute(route),
        _.extend({}, options, {
          originalRoute: route,
        })
      );
    }

    this.log.info("Navigation to " + route);

    if (options && _.size(options)) {
      this.log.info("Navigation options: ");
      this.log.info(options);
    }
  },

  operation: function (operation, options) {
    options = sterilizeOptions(options);

    if (window.Intercom) {
      //this.intercom('trackEvent', operation, options);
      window.Intercom("trackEvent", operation, options);
    }

    this.log.info('Operation "' + operation + '" invoked');

    if (options && _.size(options)) {
      this.log.info("Operation options: ");
      this.log.info(options);
    }
  },

  error: function (error) {
    this.log.error(error);
  },
};

export default new Logger();



//////////////////
// WEBPACK FOOTER
// ./public/js/app/Logger.js
// module id = 94
// module chunks = 1